const ICON_COLLAPSE = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 10}
      height={height || 10}
      viewBox="0 0 3.925 3.925"
      className="margin_left"
    >
      <path
        d="m.64 2.624 1.323-1.323 1.323 1.323z"
        style={{
          fillRule: "evenodd",
          fill: "#000",
          paintOrder: "stroke markers fill",
        }}
      />
    </svg>
  );
};

export default ICON_COLLAPSE;
